module.exports = __webpack_public_path__ + "static/media/icon-tx-confirm.2d030326.svg";